/* eslint-disable */
import { ChartOptionsBuilder } from './ChartPipeline';
import * as React from 'react';

export function useChartOptions(options: Highcharts.Options, pipes: ((options: Highcharts.Options) => Highcharts.Options)[]) {
  const builder = React.useMemo(() => new ChartOptionsBuilder(pipes), [pipes]);
  return React.useMemo(() => builder.build(options), [options]);
}